import React from 'react';
import { Card, Spin, Alert, Button } from 'antd';
import EmployeesTable from './EmployeesTable.js';
import { useEmployees } from '../../../hooks/useEmployees';

const Employees = ({ page }) => {
  const { 
    data: subscriptions, 
    isLoading, 
    error, 
    refetch 
  } = useEmployees(page?._id);

  // Loading state
  if (isLoading) {
    return (
      <div className="flex justify-center items-center py-12">
        <Spin size="large" />
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <Alert
        message="Erreur lors du chargement des employés"
        description={error.message || 'Une erreur est survenue.'}
        type="error"
        showIcon
        action={
          <Button onClick={() => refetch()}>
            Réessayer
          </Button>
        }
      />
    );
  }

  return (
    <div className='h-full m-4 md:w-full flex flex-col gap-6'>
      <Card className='w-full bg-royalblue-100'>
        <p className='text-royalblue-500'>
          Dans cet espace, vous pourrez retrouver vos salariés qui possèdent un abonnement Behandy. 
          Pour gérer les abonnements de vos salariés (ajouter ou supprimer), rendez-vous dans l'onglet " gestion page".
        </p>
      </Card>
      
      {subscriptions?.subscriptions && (
        <EmployeesTable datas={subscriptions.subscriptions} />
      )}
    </div>
  );
};

export default Employees;